import type { JSX } from 'react';
import {
  ExperimentOutlined,
  FileTextOutlined,
  FormOutlined,
  LinkOutlined,
  AppstoreOutlined,
  PlayCircleOutlined,
  ReadOutlined,
  SolutionOutlined,
} from '@ant-design/icons';

import type { LessonType } from './wikiApi';

/** Подписи/иконки типов уроков (фаза 2.1) — общие для читалки и конструктора. */
export const LESSON_TYPE_META: Record<LessonType, { label: string; color: string; icon: JSX.Element }> = {
  article: { label: 'Текст', color: 'var(--fk-info)', icon: <FileTextOutlined /> },
  video: { label: 'Видео', color: '#7E3FB8', icon: <PlayCircleOutlined /> },
  quiz: { label: 'Тест', color: 'var(--fk-success)', icon: <ReadOutlined /> },
  trainer: { label: 'Тренажёр', color: 'var(--fk-orange)', icon: <ExperimentOutlined /> },
  practical: { label: 'Практика', color: '#0F6FC0', icon: <SolutionOutlined /> },
  survey: { label: 'Опрос', color: '#C0392B', icon: <FormOutlined /> },
  external: { label: 'Внешний', color: 'var(--fk-text-2)', icon: <LinkOutlined /> },
  scorm: { label: 'SCORM-курс', color: '#0096FF', icon: <AppstoreOutlined /> },
};

export const LESSON_TYPES_ORDER: LessonType[] = ['article', 'video', 'quiz', 'trainer', 'scorm', 'external', 'practical', 'survey'];

export function lessonMeta(type: string): { label: string; color: string; icon: JSX.Element } {
  return LESSON_TYPE_META[type as LessonType] ?? LESSON_TYPE_META.article;
}

export function formatMinutes(min: number | null | undefined): string {
  if (!min || min <= 0) return '';
  if (min < 60) return `${min} мин`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m ? `${h} ч ${m} мин` : `${h} ч`;
}
